import classNames from "classnames";
import React from "react";

interface ButtonButtonProps extends React.ComponentPropsWithoutRef<"button"> {
  tag?: "button";
}

interface ButtonLinkProps extends React.ComponentPropsWithoutRef<"a"> {
  tag: "a";
}

type ButtonProps = (ButtonButtonProps | ButtonLinkProps) & {
  className?: string;
  component?: any;
  color?: string;
  size?: string;
  loading?: boolean;
  wide?: boolean;
  wideMobile?: boolean;
  disabled?: boolean;
  href?: string;
  to?: string; // Hack for <Link> component
};

const Button: React.FunctionComponent<ButtonProps> = ({
  className = "",
  tag = "button",
  component,
  color = "",
  size = "",
  loading = false,
  wide = false,
  wideMobile = false,
  disabled = false,
  ...props
}) => {
  const classes = classNames(
    "button",
    color && `button-${color}`,
    size && `button-${size}`,
    loading && "is-loading",
    wide && "button-block",
    wideMobile && "button-wide-mobile",
    className
  );

  const Component = component || tag;
  return <Component {...props} className={classes} disabled={disabled} />;
};

export default Button;
